import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

interface ProductChangesToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	onAdd: () => void;
}

export const ProductChangesToolbar = ({
	search,
	onSearchChange,
	onAdd,
}: ProductChangesToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				mb: 1,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				ADD PRODUCT CHANGE
			</Button>
		</Box>
	);
};
